import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function createCollectionRequest(payload) {
  try {
    const url = paths.createCollectionRequest();
    const response = await axiosInstance.post(url, payload);

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

const useCreateCollectionRequest = () => {
  return useMutation({
    mutationFn: createCollectionRequest,
  });
};

export { useCreateCollectionRequest };
